<template>
  <div class="pt1 pb1 px1 subtle relative">
    <h2>Tasks</h2>
    <p class="right align-right absolute right-0 top-0 mt1 mr1">
      <button
        v-if="tasks.length"
        class="invisible-button small-button"
        @click.prevent="isEditing =! isEditing">
        <template v-if="!isEditing">Edit</template>
        <template v-else>Done</template>
      </button>
    </p>

    <lw-table
      v-if="!tasksLoading"
      :type="'lined'"
      :class="'clear list-group table--tight'"
      :size="'table--mobile'"
      :draggable="true"
      :headings="[
        '',
        'Task',
        'Role',
        'Person',
        'Likely ' + rateUnit[estimate.rateType].label + 's',
        'High ' + rateUnit[estimate.rateType].label + 's',
        ''
      ]"
      :alignment="[
        'left',
        'left',
        'left',
        'left',
        'right',
        'right',
        ''
      ]"
      :widths="[
        '0',
        '45',
        '15',
        '15',
        '10',
        '10',
        '0'
      ]"
      :tips="[
        '',
        '',
        '',
        '',
        'This is your best, most realistic guess.',
        'This is your 90th percentile guess. Safe enough that you could bet $1000 that you‘d hit this estimate 9 times out of 10. Not that we condone gambling.',
        ''
      ]"
    >
      <transition name="task">
        <pi-draggable
          v-model="tasks"
          :options="{draggable:'.item', handle: '.handle'}"
          :element="'tbody'">
          <app-estimate-task
            v-for="(task, index) in tasks"
            ref="task"
            :task="task"
            :estimate="page"
            :assigned-to="task.person"
            :skill="task.role"
            :key="index"
            :is-editing="isEditing"
            :class="'item'"
            :item="task"
            :unit="rateUnit[estimate.rateType].label + 's'"
          />
        </pi-draggable>
      </transition>
      <tr class="grey-200 font-size-2 summary">
        <td class="hidden_mb"/>
        <td class="mono">Tasks: <strong>{{ tasks.length }}</strong></td>
        <td class="mono">Roles: <strong>{{ Object.keys(estimate.roles).length }}</strong></td>
        <td class="mono">Team size: <strong>{{ Object.keys(estimate.team).length }}</strong></td>
        <td class="bold numeric mono font-size-3_sm"><span class="hide_sm sans">Low time: </span>{{ estimate.lowTime | round2 }}</td>
        <td class="bold numeric mono font-size-3_sm"><span class="hide_sm sans">High time: </span>{{ estimate.highTime | round2 }}</td>
        <td class="hidden_mb"/>
      </tr>
    </lw-table>
    <button
      class="accent-button full-button_mb mb0_sm left"
      @click="addTask">+ Add task</button>
    <app-export-estimate
      :page="page"
      :name="estimate.client + '-' + estimate.project"
      :class="'mb0 right_sm'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'
import EstimateTask from './EstimateTask'
import Table from '../livewires/Table'
import ExportEstimate from './ExportEstimate'

export default {
  components: {
    appEstimateTask: EstimateTask,
    lwTable: Table,
    piDraggable: Draggable,
    appExportEstimate: ExportEstimate
  },
  data () {
    return {
      page: this.$route.params.id,
      isEditing: false
    }
  },
  computed: {
    ...mapGetters([
      'organization',
      'user'
    ]),
    tasksLoading () {
      return this.$store.getters.tasksLoading
    },
    estimate () {
      return this.$store.getters.estimate(this.page)
    },
    tasks: {
      get () {
        return this.$store.getters.tasks(this.page)
      },
      set (value) {
        this.$store.dispatch('saveState', false)
        this.$store.dispatch('orderTasks', value)
      }
    },
    rateUnit () {
      return this.$store.getters.rateUnits(this.estimate.rateCard)
    }
  },
  methods: {
    addTask () {
      this.$store.dispatch('saveState', false)
      const payload = {
        estimate: this.page,
        order: this.tasks.length,
        organization: this.organization.id,
        owner: this.user.id
      }
      this.$store.dispatch('addTask', payload)
    }
  }
}
</script>

<style scoped>
  .component-fade-enter-active {
    animation: slide-in .2s ease-out forwards;
  }
  .component-fade-leave-active {
    animation: slide-out .3s ease-in forwards;
  }
  @media screen and (max-width: 48em) {
    .summary {
      width: 100%;
      clear: both;
      display: block;
      padding-top: calc(var(--line)* 0.25);
    }
    .summary td {
      width: 20%;
    }
    .summary td.mono.numeric {
      text-transform: none;
      font-weight: var(--regular);
      text-align: right;
    }
  }
  @keyframes slide-in {
    from {
      transform: translateX(-100%);
    }
    to {

      transform: translateX(0%);
    }
  }
  @keyframes slide-out {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(100%);
    }
  }
</style>
